import { useState } from "react";
import { Grid, MenuItem, Button } from "@mui/material";
import { t } from "i18next";
import AppConfig from "../../../../../helpers/constants/AppConfig";
import ChartTypes from "../../../../../helpers/constants/ChartTypes";
import SelectDomain from "../../../../../components/SelectDomain";
import SelectCustom from "../../../../../components/SelectCustom";
import SiteSelect from "../../../../../components/SiteSelect";

function Filter({ filterData, setFilterData, handleGraphChange }) {
  const types = ChartTypes;
  const [errors, setErrors] = useState({});

  const handleChange = (e, name) => {
    setFilterData({
      ...filterData,
      [name]: e
    });
    setErrors({
      ...errors,
      [name]: null
    });
  };

  const onSearch = () => {
    let temp_errors = {};

    if (filterData.ip === "") {
      temp_errors.ip = t("message.required", { item: t("site.site") });
    }
    if (filterData.domain === "") {
      temp_errors.domain = t("message.required", { item: t("domain.domain") });
    }
    if (filterData.item === "") {
      temp_errors.item = t("message.required", { item: t("global.type") });
    }

    setErrors(temp_errors);

    if (Object.keys(temp_errors).length === 0) {
      handleGraphChange(filterData);
    }
  }

  return (
    <Grid container justifyContent="center"
          sx={{ mt: 1, mb: 1 }} alignItems="start"
    >
      <Grid item md={4} xs={12}>
        <SiteSelect
          value={filterData.ip}
          onChange={(e) => handleChange(e.target.value, "ip")}
          error={errors?.ip}
          hasAll
        />
      </Grid>

      <Grid item md={4} xs={12} pl={{ md: 2, xs: 0 }} mt={{ xs: 2, md: 0 }}>
        <SelectDomain
          value={filterData.domain}
          onChange={(e) => handleChange(e.target.value, "domain")}
          error={errors?.domain}
        />
      </Grid>

      <Grid item md={4} xs={12} pl={{ md: 2, xs: 0 }} mt={{ xs: 2, md: 0 }}>
        <SelectCustom
          id="item-select"
          value={filterData.item}
          error={errors?.item}
          label={t("global.type")}
          onChange={(e) => handleChange(e.target.value, "item")}
        >
          {types.map((t, i) => {
            return <MenuItem value={t.value} key={i}>{t.name}</MenuItem>
          })}
        </SelectCustom>
      </Grid>

      <Grid item md={12} xs={12} mt={2} className="d-flex justify-content-center">
        <Button
          onClick={onSearch}
          variant="outlined" color={AppConfig.color} className="button-fw-normal"
        >
          {t("button.view")}
        </Button>
      </Grid>
    </Grid>
  );
}

export default Filter;
